export default __webpack_public_path__ + "static/media/VJA-6.51fe923c.webp";